module.exports = __webpack_public_path__ + "static/media/8. Ignición, Mixta en tela, 150 x 150 cm, 2017 copy.89df08d6.png";